
import React from 'react';
import { Bell } from 'lucide-react';
import { Badge } from '@/components/ui/badge';

interface NotificationBellProps {
  count: number;
}

const NotificationBell = ({ count }: NotificationBellProps) => {
  return (
    <div className="relative">
      <button 
        className="p-2 rounded-full hover:bg-[#F5F5F7] transition-colors duration-200"
        aria-label={`${count} unread notifications`}
      >
        <Bell size={20} className="text-[#1A2033]" />
        {count > 0 && (
          <Badge className="absolute -top-1 -right-1 h-5 min-w-5 p-0 flex items-center justify-center bg-red-500 text-white text-xs rounded-full">
            {count > 9 ? '9+' : count}
          </Badge>
        )}
      </button>
    </div>
  );
};

export default NotificationBell;
